/**
 * Extracts the alpha value from a hexadecimal color code.
 *
 * @param {string} hexCode - The hexadecimal color code.
 * @returns {number|null} The alpha value of the color as a percentage (0-100), or null if the input is invalid.
 */
const getAlphaFromHex = (hexCode) => {
  if (hexCode.length <= 7) {
    return null;
  }

  const cleanedHexCode = hexCode.startsWith('#') ? hexCode.slice(1) : hexCode;

  const alphaHex = cleanedHexCode.slice(-2);
  const alphaDecimal = parseInt(alphaHex, 16);

  return Math.round((alphaDecimal / 255) * 100);
};

export default getAlphaFromHex;
